<div class="container">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner" style="font-size: 60px;font-weight: bold"></i>
  </div>
  }

  <div class="container-header">
    <span class="title">{{ 'TRANSLATE.SALES.CHANNEL' | translate }}</span>
  </div>

  <div class="sales-channel-body">
    <section class="sales-channel-shell">
      <article class="channel-card" aria-label="Sales channel visual">
        <div class="channel-visual">
          <img class="image" src="./../../../assets/image/vin/concessionaria.png" alt="">
        </div>
        <span class="channel-badge">{{ 'TRANSLATE.UPPERCASE.CHANNEL.DEALERS' | translate }}</span>
      </article>

      <article class="channel-form-card" aria-label="Chassis entry">
        <span class="chassi-label" [innerHTML]="chassisPromptLabel"></span>

        <div class="chassi-input-row">
          <input pInputText type="text" class="chassi-input" (keyup)="onKeyUp($event)" [(ngModel)]="chassi"
            maxlength="17" [style]="inputChassiStyleCss"
            [attr.aria-label]="'TRANSLATE.INSERT.THE.CHASSIS' | translate" />
        </div>
      </article>
    </section>

    <!--
      15 DE JAN. DE 2024 ATENÇÃO: ESSE CAMPO DEVE PERMANECER COMENTADO ATÉ DEFINIREM QUANDO SERÁ UTILIZADO

      <div class="col-12" style="text-align: center;">
        <span class="chassi-label margin-top-5">{{ 'TRANSLATE.CHASSI.INFORMATION' | translate }}</span>
      </div>

      <div class="col-12" style="text-align: center;">
        <table align="center">
          <tr>
            <td>
              <span style="color: #1874CD; font-weight: bold;">{{ 'TRANSLATE.NOT' | translate }}</span>
            </td>
            <td>&nbsp;&nbsp;</td>
            <td>
              <p-inputSwitch disabled="true" [(ngModel)]="isChassi">
              </p-inputSwitch>
            </td>
            <td>&nbsp;&nbsp;</td>
            <td>
              <span style="color: #1874CD; font-weight: bold;">{{ 'TRANSLATE.YES' | translate }}</span>
            </td>
          </tr>
        </table>
        <hr class="margin-top-5" />
      </div>
      -->

    <div class="button-position">
      <app-cta-button [label]="'TRANSLATE.ADVANCE'" icon="pi-arrow-right"
        [disabled]="blockedUi || vinValidate?.validated !== isValidChassi || errorMessageVin === 'VIN.ERROR.SAVE_VECTOR'"
        [successState]="isValidationSuccess" (buttonClick)="buttonNext()">
      </app-cta-button>
    </div>
  </div>

</div>